import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router";
import styles from './index.module.css';
import { Navbar, NavbarBrand, Progress, Button } from 'reactstrap';
import logoHb4RedColorida from '../../assets/images/hb4_reduzida_colorida.png';
import api from '../../service/api';
import Respostas from '../../components/Respostas/RespostasComponent.js';
import ModalEnvioQuestionario from '../../components/ModalEnvioQuestionario/ModalEnvioQuestionarioComponent.js';
import useDidUpdateEffect from '../../components/UseDidUpdateEffect/useDidUpdateEffect.ts';

function Perguntas(props) {

    const [qtdPerguntas, setQtdPerguntas] = useState(0);
    const [perguntaAtual, setPerguntaAtual] = useState(0);
    const [respostaSelecionanda, setRespostaSelecionada] = useState("");
    const [respostas, setRespostas] = useState([]);
    const [perguntas, setPerguntas] = useState([]);
    const [finalizado, setFinalizado] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Verifica se o termo foi aceito
        const termoAceito = localStorage.getItem(`termoAceito_${id}`);
        if (!termoAceito) {
            localStorage.setItem("perguntasId", id);
            navigate(`/termo`);
            return;
        }
    }, [navigate, id]);

    useEffect(() => {
        api.post('/visualizacaoQuestionario', {
            envio_id: id
        }).then(() => {
            console.log("Visualização registrada com sucesso.");
        }).catch((error) => {
            console.error("Erro ao registrar visualização:", error);
        });
    }, [id]);

    useEffect(() => {
        api.get('perguntas/' + id).then(({ data }) => {

            const dataSort = data.sort(function (obj1, obj2) {
                return obj1.id - obj2.id;
            });
            setPerguntas(dataSort);
            setQtdPerguntas(dataSort.length);
            const parceiro_Vida = { parceiro_vida: id };
            setRespostas((prevRespostas) => [...prevRespostas, parceiro_Vida]);
            setPerguntaAtual(1);
        });
    }, [id]);

    useDidUpdateEffect(() => {
        if (respostas.length === 1 || finalizado) {
            return;
        }

        let proximaPerguntaDefinida = false;

        const idsPerguntasBurnout = ['91', '92', '93'];

        if (perguntas[perguntaAtual - 1].id === '93') {
            const respostasChave = respostas.filter((res) => idsPerguntasBurnout.includes(res.pergunta_id));

            if (respostasChave.length > 0) {
                const todasNunca = respostasChave.every(
                    (res) => res.resposta === "Nunca"
                );

                if (todasNunca) {                
                    setFinalizado(true);
                    setPerguntaAtual(perguntas[perguntaAtual - 1].proxima_pergunta_nao);
                } else {
                    setPerguntaAtual(perguntas[perguntaAtual - 1].proxima_pergunta_sim);
                }
                setRespostaSelecionada("");
            }
        }

        if (proximaPerguntaDefinida) {
            setRespostaSelecionada("");
            return;
        }
        
        if (perguntas.length < 102) {
            setPerguntaAtual(perguntaAtual + 1);
            setRespostaSelecionada("");
        } else {
            if (perguntas[perguntaAtual - 1].pergunta_chave === true) {
                const ultimaResposta = respostas[respostas.length - 1].resposta;
                const ultimoId = respostas[respostas.length - 1].pergunta_id;
            
                const condicoesSim = {
                    "Quase sempre": ['16', '25', '37', '49'],
                    "Sempre": ['16', '25', '37', '49', '93'],
                    "Sim": ['74', '75'],
                    "Raramente": ['93'],
                    "Algumas vezes": ['93'],
                    "Frequentemente": ['93'],
                };
            
                const proximaSim = Object.keys(condicoesSim).some((resposta) => 
                    resposta === ultimaResposta && condicoesSim[resposta].includes(ultimoId)
                );
            
                if (proximaSim) {
                    setPerguntaAtual(perguntas[perguntaAtual - 1].proxima_pergunta_sim);
                } else {
                    setPerguntaAtual(perguntas[perguntaAtual - 1].proxima_pergunta_nao);
                }
                
                setRespostaSelecionada("");
            } else {
                setPerguntaAtual(perguntaAtual + 1);
                setRespostaSelecionada("");
            }
        }

        if(perguntaAtual >= qtdPerguntas){
            setFinalizado(true);
        }

    }, [respostas]);

    const getResposta = (value) => {
        setRespostaSelecionada(value);
    }

    const salvaResposta = () => {
        const res = { pergunta_id: perguntas[perguntaAtual - 1].id, resposta: respostaSelecionanda };
        setRespostas((prevRespostas) => [...prevRespostas, res]);
    }

    const handleSubmit = (respostas) => {
        return <ModalEnvioQuestionario respostas={respostas} />
    }

    return (
        <div className={styles.mainDiv}>
            <Navbar expand="sm" className={styles.navbar} >
                <NavbarBrand>
                    <div className={styles.divImage}>
                        <img src={logoHb4RedColorida} alt="" className={styles.image} />
                    </div>
                </NavbarBrand>
            </Navbar>
            <div className={styles.containerVerde}>
                <div className={styles.title}>
                    Olá, seja bem-vindo(a)!
                </div>
                <div className={styles.info}>
                    <p>Responda as perguntas abaixo</p>
                </div>
            </div>
            <div className={styles.containerBranco}>
                <div className={styles.progress}>
                    Seu progresso:
                </div>
                <div className={styles.divProgress}>
                    {/**
                    <div className={styles.progressNum}>
                        {perguntaAtual > qtdPerguntas ? qtdPerguntas : perguntaAtual} de {qtdPerguntas}
                    </div>
                     */}
                    <Progress max={qtdPerguntas} value={perguntaAtual} className={styles.progressBar} color="success" />
                </div>
                <div className={styles.balaoPergunta}>
                    <div className={styles.pergunta}>
                        {finalizado ? handleSubmit(respostas) : perguntas[perguntaAtual - 1]?.pergunta ?? <p>Atualizando pergunta</p>}
                    </div>
                </div>
                {}
                <div className={styles.balaoResposta}>
                    <div className={styles.resposta}>
                        {respostaSelecionanda}
                    </div>
                </div>
            </div>
            <div className={styles.containerCinza}>
                Sua resposta:
                <Respostas tipo={perguntas[perguntaAtual - 1]?.tipo_resposta ?? 0} getResposta={getResposta} />
                <Button
                    className={styles.buttonEnviar}
                    size="sm"
                    disabled={respostaSelecionanda ? false : true}
                    onClick={() => salvaResposta()}
                >
                    Enviar
                </Button>
            </div>
        </div >
    );
}

export default Perguntas;
